module.exports = __webpack_public_path__ + "static/media/baño-visita.8b65be8a.jpg";